// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xVLmt","label":"styles_label__1U2GE"};